/* global moment */
import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'

// Login
import Login from '@/views/Login'
import ChangePassword from '@/views/ChangePassword'
import GeneratePassword from '@/views/GeneratePassword'

// Home
import Home from '@/views/Home'

// Club
import ClubProfile from '@/views/club/Club.vue'
import SelClub from '@/views/club/SelClub.vue'
import ClubEdit from '@/views/club/ClubEdit.vue'
import Uniforms from '@/views/club/Uniforms.vue'

// Team
import TeamsList from '@/views/team/TeamsList.vue'
import TeamProfile from '@/views/team/Team.vue'
import TeamEdit from '@/views/team/TeamEdit.vue'
import GestorForm from '@/views/team/gestor/GestorForm.vue'
import Travels from '@/views/team/Travel.vue'
import TravelForm from '@/views/team/TravelForm.vue'
import Insurances from '@/views/team/Insurance.vue'
import Opening from '@/views/team/Opening.vue'
import Finals from '@/views/team/Finals.vue'
import Credentials from '@/views/team/Credentials.vue'
import ImageRights from '@/views/team/ImageRights.vue'
import Payments from '@/views/team/Payments.vue'
import Hotels from '@/views/team/Hotels.vue'
import Sanctions from '@/views/team/Sanctions.vue'
import Matches from '@/views/team/Matches.vue'

// Person
import EntityList from '@/views/person/EntityList.vue'
import PersonForm from '@/views/person/PersonForm.vue'
import PersonProfile from '@/views/person/PersonProfile.vue'

// Campus
import CampusHome from '@/views/campus/Home.vue'
import CampusPersonEdit from '@/views/campus/PersonEdit.vue'
import CampusInfoEdit from '@/views/campus/CampusInfoEdit.vue'
import CampusDocuments from '@/views/campus/Documents.vue'
import CampusPhotos from '@/views/campus/Photos.vue'
import CampusTravels from '@/views/campus/Travel.vue'
import CampusTravelForm from '@/views/campus/TravelForm.vue'
import CampusRooms from '@/views/campus/Rooms.vue'
import CampusTraining from '@/views/campus/Training.vue'
import CampusGiftPGA from '@/views/campus/GiftPGA.vue'

// Payments
import goToRedsys from '@/views/goToRedsys.vue'
import ClubPayments from '@/views/club/ClubPayments.vue'

// Sign Documents
import SignDocument from '@/views/signDocument.vue'

// Players
import Players from '@/views/players/Players.vue'

import i18n from '@/i18n'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: requireEvent
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        layout: 'login'
      },
      beforeEnter: loadData
    },
    {
      path: '/:event',
      name: 'home_event',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/:event/home',
      name: 'campus_home',
      component: CampusHome,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/login',
      name: 'event_login',
      component: Login,
      meta: {
        layout: 'login'
      },
      beforeEnter: loadData
    },
    {
      path: '/login/:lang',
      name: 'login_with_lang',
      component: Login,
      meta: {
        layout: 'login'
      },
      beforeEnter: loadData
    },
    {
      path: '/:event/login/:lang',
      name: 'event_login_with_lang',
      component: Login,
      meta: {
        layout: 'login'
      },
      beforeEnter: loadData
    },
    {
      path: '/:event/selclub',
      name: 'sel_club',
      component: SelClub,
      meta: {
        layout: 'login'
      },
      beforeEnter: requireAuth
    },
    {
      path: '/:event/club',
      name: 'club',
      component: ClubProfile,
      beforeEnter: requireAuth
    },
    {
      path: '/:event/club/edit',
      name: 'club_edit',
      component: ClubEdit,
      beforeEnter: requireAuth
    },
    {
      path: '/:event/club/uniforms',
      name: 'uniforms',
      component: Uniforms,
      beforeEnter: requireAuth
    },
    {
      path: '/:event/club/payments',
      name: 'club-payments',
      component: ClubPayments,
      beforeEnter: requireAuth
    },
    {
      path: '/:event/team/:id',
      name: 'team',
      component: TeamProfile,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:id/edit',
      name: 'team_edit',
      component: TeamEdit,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/players',
      name: 'players',
      component: Players,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/player/:person_id',
      name: 'player',
      component: PersonProfile,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:id/players/add',
      name: 'players_add',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/player/:person_id/edit',
      name: 'player_edit',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/staff',
      name: 'staff',
      component: EntityList,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/staff/:person_id',
      name: 'coach',
      component: PersonProfile,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:id/staff/add',
      name: 'staff_add',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/staff/:person_id/edit',
      name: 'staff_edit',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/responsables',
      name: 'responsables',
      component: EntityList,
      beforeEnter: requireAuth
    },
    {
      path: '/:event/responsable/:person_id',
      name: 'responsable',
      component: PersonProfile,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:id/responsables/add',
      name: 'responsables_add',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/responsable/:person_id/edit',
      name: 'responsable_edit',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/acompanyants',
      name: 'acompanyants',
      component: EntityList,
      beforeEnter: requireAuth
    },
    {
      path: '/:event/acompanyant/:person_id',
      name: 'acompanyant',
      component: PersonProfile,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:id/acompanyants/add',
      name: 'acompanyants_add',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/acompanyants/:person_id/edit',
      name: 'acompanyant_edit',
      component: PersonForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/sanctions',
      name: 'sanctions',
      component: Sanctions,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/matches',
      name: 'matches',
      component: Matches,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/travels',
      name: 'travels',
      component: Travels,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/new_travel',
      name: 'travel_add',
      component: TravelForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/edit_travel',
      name: 'travel_edit',
      component: TravelForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/insurance',
      name: 'insurances',
      component: Insurances,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/opening',
      name: 'opening',
      component: Opening,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/finals',
      name: 'finals',
      component: Finals,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/finals/saturday',
      name: 'finals_saturday',
      component: Finals,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/credentials',
      name: 'credentials',
      component: Credentials,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/teams',
      name: 'teams',
      component: TeamsList,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/gestor/add',
      name: 'gestorAdd',
      component: GestorForm,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/image-rights',
      name: 'image-rights',
      component: ImageRights,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/payments',
      name: 'payments',
      component: Payments,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/payments/payment-form',
      name: 'payment-form',
      component: goToRedsys,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/team/:team_id/hotels',
      name: 'hotels',
      component: Hotels,
      beforeEnter: requireAuth
    },

    {
      path: '/:event/campus/payments',
      name: 'campus_payments',
      component: Payments,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },

    {
      path: '/:event/campus/payments/confirm-payment',
      name: 'confirm-payment',
      component: goToRedsys,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },

    {
      path: '/:event/campus/participant/:person_id/edit',
      name: 'participant_edit',
      component: CampusPersonEdit,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/campus/participant_campus/:person_id/edit',
      name: 'participant_campus_edit',
      component: CampusInfoEdit,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/campus/rooms',
      name: 'campus_rooms',
      component: CampusRooms,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/campus/training',
      name: 'campus_training',
      component: CampusTraining,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/campus/gift',
      name: 'campus_giftpga',
      component: CampusGiftPGA,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/campus/documents',
      name: 'campus_documents',
      component: CampusDocuments,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/campus/travels',
      name: 'campus_travels',
      component: CampusTravels,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },

    {
      path: '/:event/campus/new_travel',
      name: 'campus_travel_add',
      component: CampusTravelForm,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },

    {
      path: '/:event/campus/edit_travel',
      name: 'campus_travel_edit',
      component: CampusTravelForm,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/:event/campus/photos',
      name: 'campus_photos',
      component: CampusPhotos,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },

    {
      path: '/:event/payment-completed',
      name: 'payment-completed',
      component: goToRedsys,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },

    {
      path: '/:event/error-tpv',
      name: 'error-tpv',
      component: goToRedsys,
      beforeEnter: requireAuth,
      meta: {
        layout: 'campus'
      }
    },
    {
      path: '/changepassword/:id/:limit/:lang',
      name: 'changepassword',
      component: ChangePassword,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/viewmic/:event/:entity/:entityid',
      name: 'mic_view',
      beforeEnter: requireMICUser
    },
    {
      path: '/sign-documents/:event/:document/:token',
      name: 'sign-document',
      component: SignDocument,
      beforeEnter: requireSignTokenUser
    },
    {
      path: '/:event/new-password/:lang/:user',
      name: 'new_password_event',
      component: GeneratePassword,
      meta: {
        layout: 'login'
      },
      beforeEnter: loadData
    },
    {
      path: '/new-password/:lang/:user',
      name: 'new_password',
      component: GeneratePassword,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '/new-password/:lang/:user/:time',
      name: 'new_password_time',
      component: GeneratePassword,
      meta: {
        layout: 'login'
      }
    },
    {
      path: '*',
      name: 'not_found',
      redirect: 'home',
      component: Home,
      beforeEnter: requireAuth
    }
  ]
})

/*
    This will cehck to see if the user is authenticated or not.
*/
function requireAuth (to, from, next) {
  /*
    Determines where we should send the user.
  */
  function proceed () {
    /*
        If the user has been loaded determine where we should
        send the user.
      */
    if (store.getters['user/getUserLoadStatus']() === 2) {
      /*
            If the user is not empty, that means there's a user
            authenticated we allow them to continue. Otherwise, we
            send the user back to the home page.
          */
      var oSession = store.getters['user/getSession']
      if (document.getElementById('main-content')) { document.getElementById('main-content').scrollTop = 0 }

      if (moment(oSession.exp * 1000).valueOf() > moment().valueOf()) {
        i18n
          .loadLanguageAsync(
            oSession.user.language ? oSession.user.language : 'ca'
          )
          .then(function () {
            store.dispatch('setPage', to).then(function () {
              next()
            })
          })
      } else {
        store.dispatch('logout').then(function () {
          next('login')
        })
      }
    }
  }

  /*
    Confirms the user has been loaded
  */
  if (store.getters['user/getUserLoadStatus']() !== 2) {
    /*
        If not, load the user
      */
    store.dispatch('loadUser').then(function () {
      if (store.getters['user/getUserLoadStatus']() === 2) {
        // store.dispatch( 'loadTablesRelationship' ).then( function(){
        proceed()
        // });
      } else {
        store.dispatch('logout').then(function () {
          next('login')
        })
      }
    })
  } else {
    /*
        User call completed, so we proceed
      */
    proceed()
  }
}

function loadData (to, from, next) {
  store.dispatch('loadInfo').then(function () {
    if (typeof to.params.lang !== 'undefined') {
      if (!['ca', 'es', 'en'].includes(to.params.lang)) {
        to.params.lang = 'en'
      }

      i18n.loadLanguageAsync(to.params.lang).then(function () {
        store.dispatch('setPage', to).then(function () {
          next()
        })
      })
    } else if (typeof to.params.event !== 'undefined') {
      store.dispatch('setPage', to).then(function () {
        next()
      })
    } else {
      i18n.loadLanguageAsync('ca').then(function () {
        store.dispatch('setPage', to).then(function () {
          next()
        })
      })
    }
  })
}

function requireEvent (to, from, next) {
  /*
      Determines where we should send the user.
    */
  function proceed () {
    /*
          If the user has been loaded determine where we should
          send the user.
        */
    if (store.getters['user/getUserLoadStatus']() === 2) {
      /*
              If the user is not empty, that means there's a user
              authenticated we allow them to continue. Otherwise, we
              send the user back to the home page.
            */
      var oSession = store.getters['user/getSession']
      if (document.getElementById('main-content')) { document.getElementById('main-content').scrollTop = 0 }

      if (moment(oSession.exp * 1000).valueOf() > moment().valueOf()) {
        i18n
          .loadLanguageAsync(
            oSession.user.language ? oSession.user.language : 'ca'
          )
          .then(function () {
            store.dispatch('setPage', to).then(function () {
              next({
                name: 'home_event',
                params: {
                  event: (
                    oSession.user.event_name +
                    oSession.user.event_edition.substring(2)
                  ).toLowerCase()
                }
              })
            })
          })
      } else {
        store.dispatch('logout').then(function () {
          next('login')
        })
      }
    }
  }

  /*
      Confirms the user has been loaded
    */
  if (store.getters['user/getUserLoadStatus']() !== 2) {
    /*
          If not, load the user
        */
    store.dispatch('loadUser').then(function () {
      if (store.getters['user/getUserLoadStatus']() === 2) {
        // store.dispatch( 'loadTablesRelationship' ).then( function(){
        proceed()
        // });
      } else {
        store.dispatch('logout').then(function () {
          next('login')
        })
      }
    })
  } else {
    /*
          User call completed, so we proceed
        */
    proceed()
  }
}

function requireMICUser (to, from, next) {
  to.params.token = to.query.token
  store.dispatch('loadMICUser', to.params).then(function () {
    next('/')
  })
}

function requireSignTokenUser (to, from, next) {
  store.dispatch('loadSignTokenUser', to.params).then(function () {
    next()
  })
}
